import React, { useState } from 'react';
import { Award, ChevronDown, ChevronUp } from 'lucide-react';

// Health Grade Component - Shows channel health score as A/B/C/D
export function HealthGrade({ grade, score, breakdown }) {
  const [open, setOpen] = useState(false);
  const gradeConfig = {
    'A': { color: '#10B981', bg: 'from-[#10B981]/30 to-[#10B981]/10', label: 'Excellent' },
    'B': { color: '#3B82F6', bg: 'from-[#3B82F6]/30 to-[#3B82F6]/10', label: 'Good' },
    'C': { color: '#F59E0B', bg: 'from-[#F59E0B]/30 to-[#F59E0B]/10', label: 'Average' },
    'D': { color: '#E63946', bg: 'from-[#E63946]/30 to-[#E63946]/10', label: 'Needs Work' },
  };

  const config = gradeConfig[grade] || gradeConfig['C'];

  return (
    <div className={`relative rounded-xl p-6 bg-gradient-to-br ${config.bg} border border-[${config.color}]/30`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-[#9CA3AF] uppercase tracking-wider mb-1">Health Score</p>
          <div className="flex items-baseline gap-2">
            <span className="text-5xl font-black" style={{ color: config.color }}>{grade}</span>
            <span className="text-lg text-[#9CA3AF]">/ {score}%</span>
          </div>
          <p className="text-sm mt-1" style={{ color: config.color }}>{config.label}</p>
        </div>
        <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: `${config.color}20` }}>
          <Award size={32} style={{ color: config.color }} />
        </div>
      </div>

      {breakdown && breakdown.length > 0 && (
        <>
          <button
            onClick={() => setOpen(o => !o)}
            className="mt-3 flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-[#9CA3AF] hover:text-white transition-colors"
            data-testid="health-breakdown-toggle"
          >
            {open ? 'Hide' : 'Show'} breakdown
            {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
          </button>
          {open && (
            <div className="mt-3 space-y-1.5 pt-3 border-t border-white/5">
              {breakdown.map((b, i) => (
                <div key={i} className="flex items-center justify-between text-[11px]">
                  <span className="text-[#9CA3AF]">{b.label}</span>
                  <span className="font-mono font-semibold" style={{ color: b.pct >= 0.7 ? '#10B981' : b.pct >= 0.4 ? '#F59E0B' : '#E63946' }}>
                    {b.score}/{b.max}
                  </span>
                </div>
              ))}
              <p className="text-[10px] text-[#9CA3AF] pt-2 leading-relaxed">
                Tip: Improve weakest metric first. Each point earned moves you closer to next grade.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default HealthGrade;
